function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentElectricMoneyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.069V27.93h12.007V4.069H4zm-2-.285c0-.762.543-1.715 1.591-1.715h12.825c1.049 0 1.591.953 1.591 1.715v24.432c0 .762-.542 1.715-1.591 1.715H3.59C2.543 29.93 2 28.978 2 28.216V3.784z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.523 22v-2.574h1.1V22h-1.1zM9.523 13.574V11h1.1v2.574h-1.1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.063 18.175a.56.56 0 00-.245-.477c-.164-.119-.456-.24-.876-.364l-.608-.173c-.732-.208-1.266-.496-1.605-.864-.339-.368-.507-.85-.507-1.44 0-.516.125-.966.373-1.35a2.481 2.481 0 011.057-.898c.456-.215.982-.322 1.582-.322.529 0 1.025.076 1.488.225.463.15.854.36 1.174.629l-.689 1.67c-.584-.53-1.238-.795-1.96-.795-.312 0-.554.06-.725.179a.553.553 0 00-.256.478c0 .17.078.314.234.437.156.124.401.232.735.322l.595.162c.795.216 1.377.516 1.752.905.373.388.56.897.56 1.527 0 .53-.123.985-.368 1.365s-.595.674-1.05.882c-.457.208-1.003.31-1.642.31a5.313 5.313 0 01-1.74-.275c-.544-.185-.992-.442-1.342-.772l.689-1.67a3.14 3.14 0 002.335.98c.342 0 .602-.057.776-.173a.56.56 0 00.263-.496v-.002z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.572 9.592l.566-.703c1.483 1.843 2.299 4.292 2.299 6.898s-.816 5.055-2.299 6.898l-.566-.703c1.332-1.655 2.065-3.855 2.065-6.195 0-2.34-.733-4.54-2.065-6.195z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.528 8.576c1.561 1.94 2.409 4.504 2.409 7.211 0 2.708-.848 5.27-2.41 7.211l-.389.485-1.207-1.501.252-.314c1.252-1.556 1.954-3.642 1.954-5.88 0-2.24-.702-4.325-1.954-5.882l-.252-.314 1.207-1.5.39.484z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.008 19.677c1.885-2.145 1.885-5.635 0-7.78l.566-.644c2.196 2.5 2.197 6.568 0 9.068l-.566-.644z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.95 10.923c2.361 2.689 2.362 7.039 0 9.728l-.376.427-1.232-1.4.29-.33c1.72-1.957 1.72-5.165 0-7.12l-.29-.33 1.232-1.402.375.427zM21.4 17.598c.483-.484.75-1.127.75-1.81 0-.685-.267-1.328-.75-1.812l.565-.566a3.34 3.34 0 01.985 2.377c0 .898-.35 1.742-.985 2.377l-.566-.566z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.318 13.057a3.839 3.839 0 011.132 2.73c0 1.03-.403 2.002-1.132 2.73l-.353.354-1.273-1.273.354-.354c.39-.39.603-.906.603-1.457s-.213-1.067-.604-1.457l-.353-.354 1.273-1.273.353.354z",
    fill: props.color
  }));
}

export default SvgIconPaymentElectricMoneyFilled;